export default __webpack_public_path__ + "static/media/portfolio-madrid-3.8b5ef7ba.jpg";